var _path, _path2, _path3, _path4;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImgThanxAi(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6469 0.00217009L4.3479 1.56531C4.1539 1.66084 3.9409 1.66084 3.7729 1.56531L0.944397 0L2.0889 3.04595C2.1589 3.22398 2.1279 3.43891 2.0089 3.61911L0 6.7063L3.2949 5.12146C3.4879 5.02593 3.7019 5.02593 3.8689 5.12146L6.6999 6.7107L5.5689 3.62128C5.4989 3.44325 5.5289 3.22832 5.6489 3.04812L7.6469 0.00217009Z",
    fill: "#6A747F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8819 7.25L11.4179 8.4181C11.2749 8.4897 11.1139 8.4897 10.9899 8.4181L8.87688 7.25L9.73188 9.5253C9.78388 9.6599 9.75988 9.8184 9.67088 9.953L8.17188 12.2586L10.6309 11.0754C10.7739 11.0038 10.9349 11.0038 11.0589 11.0754L13.1749 12.2608L12.3299 9.9552C12.2779 9.8206 12.2999 9.6621 12.3909 9.5275L13.8819 7.25Z",
    fill: "#6A747F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6589 2.59387L12.5379 1.25L11.0839 1.93822C10.9989 1.97947 10.9059 1.97947 10.8319 1.93822L9.58488 1.25L10.0899 2.5917C10.1199 2.66985 10.1069 2.76538 10.0549 2.84354L9.17188 4.20477L10.6229 3.5057C10.7079 3.46445 10.8039 3.46445 10.8749 3.5057L12.1219 4.20477L11.6239 2.84354C11.5909 2.76755 11.6039 2.67202 11.6589 2.59387Z",
    fill: "#6A747F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.54028 9.2521L4.08678 9.9404C4.00188 9.9816 3.90617 9.9816 3.83437 9.9404L2.58747 9.25L3.09227 10.5917C3.12277 10.6698 3.10977 10.7653 3.05747 10.8435L2.17188 12.2069L3.62328 11.5078C3.70818 11.4666 3.80387 11.4666 3.87567 11.5078L5.12228 12.2069L4.62418 10.8457C4.59378 10.7675 4.60677 10.672 4.65907 10.5938L5.54028 9.2521Z",
    fill: "#6A747F"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgThanxAi);
export default __webpack_public_path__ + "static/media/img_thanxAi.d6e15bb94eb4aee4835de0454111b707.svg";
export { ForwardRef as ReactComponent };